module.exports = __webpack_public_path__ + "img/loadingIcon.a73fb1d5.svg";